export default "__VITE_ASSET__cz6IGURz__"